// extracted by mini-css-extract-plugin
module.exports = {"open":"head-tabs_open__q9iWz"};